import { FilePlus, FileSignature, Vote } from 'lucide-react';

/** Shareholder Approval sub-step id — sidebar + routed/embedded sub-views in `DocumentGeneration` align via these ids. */
export type DocumentsWorkflowSubId = 'generate' | 'waiver' | 'voteRoom';

export const DEFAULT_DOCUMENTS_WORKFLOW_SUB_ID: DocumentsWorkflowSubId = 'generate';

const DOCUMENTS_WORKFLOW_SUB_ITEMS_DEF = [
  { id: 'generate' as const, label: 'Documents', icon: FilePlus },
  { id: 'waiver' as const, label: '280G Waiver', icon: FileSignature },
  { id: 'voteRoom' as const, label: 'Vote Room', icon: Vote },
];

export type DocumentsWorkflowSubItem = (typeof DOCUMENTS_WORKFLOW_SUB_ITEMS_DEF)[number];

/** Canonical order of Shareholder Approval sub-steps in the workflow sidebar and document panel. */
export const DOCUMENTS_WORKFLOW_SUB_ITEMS: readonly DocumentsWorkflowSubItem[] = DOCUMENTS_WORKFLOW_SUB_ITEMS_DEF;
